import { render, staticRenderFns } from "./BookingOnlyCanceledInStayin.vue?vue&type=template&id=52dfa962&scoped=true&"
import script from "./BookingOnlyCanceledInStayin.vue?vue&type=script&lang=js&"
export * from "./BookingOnlyCanceledInStayin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dfa962",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
